import React from 'react';
import PropTypes from 'prop-types';
import { convertDataset } from 'utils/reactComponentManager';
import VideoPlaceholder from '../video';
import DisplayCaption from '../caption';

export default function MpxBlock({ html }) {
  const div = document.createElement('div');
  let captionText = '';
  div.innerHTML = html; // phpcs:ignore WordPressVIPMinimum.JS.InnerHTML.Found

  const dataset = { ...div.firstChild.dataset };

  const [, captionElem] = div.children;

  if (captionElem) {
    captionText = captionElem.innerText;
  }

  const props = {
    ...convertDataset(dataset).props,
    autoplay: true,
    excludeEndCard: true,
  };

  return (
    <>
      <VideoPlaceholder video={props} position="embed" />
      {captionText &&
        <DisplayCaption text={captionText} />
      }
    </>
  );
}

MpxBlock.propTypes = {
  html: PropTypes.string.isRequired,
};
